// eslint-disable-next-line no-unused-vars
import React from 'react';

function getMrcColumns(t: (key: string) => string) {
	return [
		{
			key: 'phone_number',
			title: t('Mobile'),
			sortable: true,
			width: 120,
		},
		{
			key: 'created_at',
			title: t('Created at'),
			sortable: false,
			width: 120,
		},
		{
			key: 'mrc_signed_at',
			title: t('Signed'),
			sortable: false,
			width: 120,
		},
		{
			key: 'mrc_rejected_at',
			title: t('Rejected'),
			sortable: false,
			width: 120,
		},
		{
			key: 'sms_sent_at',
			title: t('SMS sent'),
			sortable: false,
			width: 120,
		},
		{
			key: 'process',
			title: t('Process %'),
			sortable: false,
			width: 100,
		},
		{
			key: 'avg_time_to_sign',
			title: t('Avg time to sign'),
			sortable: false,
			width: 150,
		},
		{
			key: 'status',
			title: t('Status'),
			sortable: false,
			width: 60,
		},
	];
}

export default getMrcColumns;